import styled from 'styled-components';
import { zIndex } from 'tokens';

interface BaseProps {
	isMobile?: boolean;
	isFloating?: boolean;
}

export const Base = styled.button<BaseProps>`
	background-color: transparent;
	border: none;
	height: 44px;
	width: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 44px;
	min-height: 44px;

	${({ isFloating }) =>
		isFloating
			? `
		position: fixed;
		top: 4px;
		left: 4px;
		z-index: ${zIndex.sidebarToggle};
		border-radius: 8px;
	`
			: ''}

	&:hover {
		/* Brighten icon on hover */
		svg {
			opacity: 1;
		}
	}

	/* Default icon opacity - slightly dimmed */
	svg {
		opacity: 0.8;
		transition: opacity 0.2s ease;
	}
`;
